/**
 * Tenants CopilotKit Readable
 * Exposes tenant data to AI for context
 */

import { useCopilotReadable, useSelector } from '@ufc/core'
import { selectFilteredTenants, selectTenantsStats, selectSelectedTenant } from '../store/tenants.selectors'

export function useTenantsReadable() {
  const tenants = useSelector(selectFilteredTenants)
  const stats = useSelector(selectTenantsStats)
  const selectedTenant = useSelector(selectSelectedTenant)

  useCopilotReadable({
    description: 'Current list of tenants (organizations) in the system',
    value: {
      tenants: tenants.map(t => ({
        id: t.id,
        code: t.code,
        name: t.name,
        status: t.status,
        channel: t.channel,
        customerGroup: t.customerGroup?.name,
      })),
      stats: {
        total: stats.total,
        pending: stats.pending,
        active: stats.active,
        suspended: stats.suspended,
      },
      selectedTenant: selectedTenant ? {
        id: selectedTenant.id,
        name: selectedTenant.name,
        code: selectedTenant.code,
        status: selectedTenant.status,
        channel: selectedTenant.channel,
      } : null,
    },
  })
}
